<div [class.house-region-map-shell--compact]="compact"
     [class.house-region-map-shell--large-labels]="largeLabels"
     [class.house-region-map-shell--small-labels]="smallLabels"
     [class.house-region-map-shell--registrations]="mode === 'registrations'"
     [class.house-region-map-shell--summary]="mode === 'summary'"
     class="house-region-map-shell">
  <svg [attr.viewBox]="compact ? compactRegionMapViewBox : regionMapViewBox"
       aria-labelledby="changed-region-map-title changed-region-map-description"
       class="house-region-map" preserveAspectRatio="xMidYMid meet" role="img">
    <title id="changed-region-map-title">{{mode === 'summary' ? '내 부동산 요약 지도' : (mode === 'registrations' ? '지역별 등록 현황 지도' : '시도별 변경등기 수 지도')}}</title>
    <desc id="changed-region-map-description">
      {{mode === 'summary' ? '등기변경 알림 부동산의 위치와 최근 변경 여부를 색상 원으로 표시합니다.' : (mode === 'registrations' ? '등록 부동산 수가 많을수록 진한 파란색으로 표시됩니다.' : '변경등기 수가 많을수록 진한 빨간색으로 표시됩니다.')}}
    </desc>

    <path (click)="openRegionDetails(area)"
          (keydown.enter)="openRegionDetails(area)"
          (keydown.space)="openRegionDetails(area); $event.preventDefault()"
          *ngFor="let area of regionMapAreas"
          [attr.aria-label]="getAreaAriaLabel(area)"
          [attr.class]="getAreaClass(area)"
          [attr.d]="area.path"
          [attr.role]="mode !== 'summary' && area.count > 0 ? 'button' : null"
          [attr.tabindex]="mode !== 'summary' && area.count > 0 ? 0 : null">
      <title>{{mode === 'summary' ? area.label : area.label + ' ' + area.count + '건'}}</title>
    </path>

    <g *ngFor="let area of regionMapAreas"
       [attr.class]="'house-region-map__label' +
                     (area.compactLabel ? ' house-region-map__label--compact' : '') +
                     (area.hasWarnPeriodBadge ? ' house-region-map__label--warn' : '')"
       [attr.display]="mode !== 'changes' || area.count === 0 ? 'none' : null"
       [attr.text-anchor]="area.labelAnchor"
       [attr.transform]="'translate(' + area.labelX + ' ' + area.labelY + ')'"
       aria-hidden="true">
      <text [attr.y]="largeLabels ? -9 : -7" class="house-region-map__label-name">{{area.label}}</text>
      <circle [attr.cy]="largeLabels ? 15 : 13" [attr.r]="largeLabels ? 17 : 15"
              class="house-region-map__label-count-badge"></circle>
      <text [attr.y]="largeLabels ? 15 : 13" class="house-region-map__label-count" dy=".35em"
            text-anchor="middle">{{area.count}}</text>
    </g>

    <!-- 등록 현황은 시·군 경계의 중심점에 수량 마커를 표시한다. -->
    <g (click)="selectRegistrationMarker(marker)"
       (keydown.enter)="selectRegistrationMarker(marker)"
       (keydown.space)="selectRegistrationMarker(marker); $event.preventDefault()"
       *ngFor="let marker of registrationMapMarkers"
       [attr.aria-label]="marker.label + ' 등록 부동산 ' + marker.count + '건, 지역 목록 보기'"
       [attr.class]="'house-region-map__label house-region-map__registration-marker' +
                     (marker.hasWarnPeriodBadge ? ' house-region-map__label--warn' : '')"
       [attr.transform]="'translate(' + marker.x + ' ' + marker.y + ')'"
       role="button" tabindex="0" text-anchor="middle">
      <text [attr.y]="largeLabels ? -9 : -7" class="house-region-map__label-name">{{marker.label}}</text>
      <circle [attr.cy]="largeLabels ? 15 : 13" [attr.r]="largeLabels ? 17 : 15"
              class="house-region-map__label-count-badge"></circle>
      <text [attr.y]="largeLabels ? 15 : 13" class="house-region-map__label-count" dy=".35em"
            text-anchor="middle">{{marker.count}}</text>
    </g>

    <!-- 메인 요약 지도는 지역명과 숫자 없이 등기변경 알림 부동산의 변경 여부만 색상 원으로 구분한다. -->
    <g *ngFor="let marker of summaryMapMarkers"
       [attr.transform]="'translate(' + marker.x + ' ' + marker.y + ')'"
       aria-hidden="true" class="house-region-map__summary-marker">
      <circle [attr.class]="'house-region-map__summary-dot house-region-map__summary-dot--' + marker.tone" r="12"></circle>
    </g>
  </svg>

  <div (click)="closeRegionDetails()" *ngIf="mode === 'changes' && selectedRegionDetails"
       aria-hidden="true" class="house-region-popup-backdrop"></div>
  <div *ngIf="mode === 'changes' && selectedRegionDetails as selectedRegion"
       aria-labelledby="changed-region-popup-title"
       aria-modal="true"
       class="house-region-popup"
       role="dialog">
    <div class="house-region-popup__header">
      <div>
        <div class="house-region-popup__title" id="changed-region-popup-title">{{selectedRegion.label}}</div>
        <div class="house-region-popup__total">변경등기 {{selectedRegion.count}}건</div>
      </div>
      <button (click)="closeRegionDetails()" aria-label="지역 상세 팝업 닫기"
              class="house-region-popup__close" type="button">&times;</button>
    </div>
    <div class="house-region-popup__list">
      <div *ngFor="let item of selectedRegion.purposes" class="house-region-popup__item">
        <span>{{item.purpose}}</span>
        <strong>{{item.count}}건</strong>
      </div>
    </div>
  </div>

  <a aria-label="대한민국 지도 출처: SVG Maps, CC BY 4.0 라이선스"
     class="house-region-map__credit"
     href="https://github.com/VictorCazanave/svg-maps/tree/master/packages/south-korea"
     rel="noopener noreferrer" target="_blank">Map © SVG Maps · CC BY 4.0</a>
</div>
